'use-client'
/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  Divider,
  HStack,
  Heading,
  Spinner,
  Stack,
  Text,
  Collapse,
  Card,
  CardBody,
  VStack,
  CardFooter,
  Flex,
} from '@mybridge/ui';
import { forwardRef, useContext } from 'react';
import { SearchContext } from '../context';
import { SearchEventsFilters } from './filters';
import { SearchEventsListing } from './listing';
import { isMobile } from 'react-device-detect';
import { useDisclosure } from '@mybridge/ui';
import { Box, IconButton } from '@chakra-ui/react';
import { AlarmIcon, AuthorIconEvent, BackArrow, CalendarIcon, Filters, LinkIcon, LocationIcon } from '@mybridge/icons';
import { useDispatch, useSelector } from 'react-redux';
import Image from 'next/image';
import moment from 'moment';
// import { Link } from 'react-router-dom';
import { PostBoxContext } from 'v4/components/post/context';
import { getUserFullName } from 'v4/lib/commons';
import Link from 'next/link';
import { setIsSelectedEvent } from 'v4/store/actions/calendar.actions';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
// import { acceptEvent } from 'v4/store/actions/post.actions';
const SearchEvents =({ count, listing, ...props }) => {
  const {
    eventsSearchIsFetching,
    eventsFetchNextPage,
    eventsHasNextPage,
    eventsTotalCount,
    query,
  } = useContext(SearchContext);
  const dispatch=useDispatch();
  const { t } = useTranslator();
  const { loggedIn } = useSelector((state) => state.user);
  const filterDisc = useDisclosure();
  const { isSelectedEvent } = useSelector((state) => state.calendar);
  const {userProfileInfo, acceptEventLoading, acceptEvent } =useContext(PostBoxContext);
  const attending = isSelectedEvent?.attendees?.find?.(
    (a) => a?.user?.id === userProfileInfo?.id
  );
  return (
    <Stack>
      {isMobile ? (
        <Collapse style={{overflow:"inherit"}} in={filterDisc?.isOpen} animateOpacity>
          <SearchEventsFilters />
        </Collapse>
      ) : (
        ''
      )}
      <Stack spacing={0}>
        <HStack px={2} w="100%"
            justifyContent="space-between"
            alignItems="center"
            gap={0}>
          <Heading as="h1" fontSize="20px" color="brandPrimary.500" fontWeight="400">
         {isSelectedEvent?.id&&isSelectedEvent?.type===2&&( <Button
                  p={0}
                  color="#00000040"
                  onClick={() => {
                   dispatch(setIsSelectedEvent({}))
                  }}
                  // isLoading={loading}
                  variant={"none"}
                >
                  <BackArrow width="24" height="24" />
                </Button>)}
            
            
              {t('navigation.events') || "Events"}</Heading>
          {isMobile && <IconButton icon={<Filters />} onClick={() => filterDisc.onToggle()} variant="transparent" />}
          {eventsSearchIsFetching ? <Spinner /> : ''}
        </HStack>
        {query?.query?.length && eventsTotalCount ? (
          <Text pl={4} size="sm">{eventsTotalCount} {t('pageJobs.results') || "results"}</Text>
        ) : (
          ''
        )}
      </Stack>  
      
     { <SearchEventsListing fromModuleEvent={true} fromPublic={true} />}









      {/* {eventsHasNextPage ? (
        <Button
          isLoading={eventsSearchIsFetching}
          onClick={eventsFetchNextPage}
        >
          Load More
        </Button>
      ) : (
        ''
      )} */}
    </Stack>
  );
}

export default SearchEvents
